<!-- src/components/admin/cards/GenerateCardsDialog.vue -->
<template>
  <v-card class="rounded-xl">
    <v-sheet color="secondary" dark class="pa-4 d-flex align-center">
      <v-icon large class="mr-3">mdi-plus-circle-multiple</v-icon>
      <div class="flex-grow-1">
        <div class="text-h6 font-weight-bold">{{ $t('Générer des cartes') }}</div>
        <div class="text-caption">{{ $t('Créer plusieurs cartes physiques') }}</div>
      </div>
      <v-btn icon @click="$emit('cancel')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-sheet>
    
    <v-card-text class="pt-6">
      <v-form ref="form" @submit.prevent="generate">
        <!-- Nombre de cartes -->
        <v-text-field
          v-model.number="quantity"
          type="number"
          :label="$t('Nombre de cartes à générer') + ' *'"
          prepend-inner-icon="mdi-counter"
          outlined
          dense
          :rules="quantityRules"
          hint="Entre 1 et 1000 cartes"
          persistent-hint
        />
        
        <!-- Option: Générer PDF immédiatement -->
        <v-checkbox
          v-model="generatePDF"
          class="mt-4"
          hide-details
        >
          <template v-slot:label>
            <div class="d-flex align-center">
              <v-icon small class="mr-2">mdi-printer</v-icon>
              <span>{{ $t('Générer le PDF de toutes les cartes immédiatement') }}</span>
            </div>
          </template>
        </v-checkbox>
        
        <!-- Résumé -->
        <v-alert
          type="info"
          text
          dense
          border="left"
          class="mt-4"
        >
          <div class="d-flex align-center">
            <v-icon small class="mr-2">mdi-information</v-icon>
            <div>
              <div class="font-weight-medium">{{ $t('Résumé') }}</div>
              <div class="text-caption">
                {{ quantity }} {{ $t('carte(s) seront créées avec un code QR unique') }}
              </div>
            </div>
          </div>
        </v-alert>
      </v-form>
    </v-card-text>
    
    <v-divider />
    
    <v-card-actions class="pa-4 justify-end">
      <v-btn text @click="$emit('cancel')" :disabled="generating">
        <v-icon left>mdi-close</v-icon>
        {{ $t('actions.cancel') }}
      </v-btn>
      <v-btn
        color="secondary"
        @click="generate"
        :loading="generating"
      >
        <v-icon left>mdi-plus-circle</v-icon>
        {{ $t('Générer') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PhysicalCardService from "@/services/PhysicalCardService"

export default {
  name: "GenerateCardsDialog",
  
  data() {
    return {
      quantity: 10,
      generatePDF: false,
      generating: false,
      
      quantityRules: [
        v => !!v || this.$t('Champ requis'),
        v => v > 0 || this.$t('Minimum 1 carte'),
        v => v <= 1000 || this.$t('Maximum 1000 cartes à la fois'),
      ],
    }
  },
  
  methods: {
    async generate() {
      if (!this.$refs.form.validate()) return
      
      this.generating = true
      
      try {
        const payload = {
          quantity: this.quantity,
        }
        
        const result = await PhysicalCardService.generateCards(this, payload)
        
        // Si l'utilisateur veut le PDF immédiatement
        if (this.generatePDF && result.card_ids) {
          try {
            const blob = await PhysicalCardService.generatePDF(this, result.card_ids)
            
            // Télécharger le PDF
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `cartes_${new Date().getTime()}.pdf`
            link.click()
            window.URL.revokeObjectURL(url)
          } catch (e) {
            console.error('Erreur génération PDF:', e)
            this.$store.commit("app/message", {
              msg: this.$t('Cartes créées mais erreur PDF'),
              color: "warning"
            })
          }
        }
        
        this.$emit('generated', result)
      } catch (e) {
        const msg = e?.response?.data?.detail || this.$t("messages.error.operation_failed")
        this.$store.commit("app/message", { msg, color: "error" })
      } finally {
        this.generating = false
      }
    },
  },
}
</script>